<template>
  <component :is="currentLayoutName" />
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import SignInLayout from '@/layouts/SignIn.vue';
import '@/css/quasar.variables.scss';

export default {
  components: {
    DefaultLayout,
    SignInLayout,
  },
  computed: {
    currentLayoutName() {
      if (typeof this.$route.href === 'string') {
        if (typeof this.$route.meta?.layoutName === 'string') {
          return `${this.$route.meta.layoutName}Layout`;
        }

        return 'DefaultLayout';
      }

      return null;
    },
  },
};
</script>
